import {
  GET_ADDRESS,
  GET_ADDRESS_SUCCESS,
  GET_ADDRESS_FAILURE,
  DELETE_ADDRESS,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILURE,
  CREATE_ADDRESS_SUCCESS
} from './userProfileActions';

const initialState = {
  addresses: [],
  addressWatch: false,
  adressLoading: true
};

const initReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_ADDRESS:
    case GET_ADDRESS:
      return {
        ...state,
        adressLoading: true
      };
    case CREATE_ADDRESS_SUCCESS:
    case DELETE_ADDRESS_SUCCESS:
      return {
        ...state,
        addressWatch: !state.addressWatch,
        adressLoading: false
      };
    case GET_ADDRESS_SUCCESS:
      return {
        ...state,
        addresses: action.payload,
        adressLoading: false
      };
    case GET_ADDRESS_FAILURE:
      return {
        ...state,
        adressLoading: false
      };
    case DELETE_ADDRESS_FAILURE:
      return {
        ...state,
        adressLoading: false
      };
    default:
      return state;
  }
};

export default initReducer;
